import type { PriceScenariosProps } from "../../types";
import { Arrow } from "../Arrow";
import { IntroFee } from "../IntroFee";

export const IntroFeeWithArrow = (props: PriceScenariosProps) => (
  <Arrow>
    <IntroFee {...props} />
  </Arrow>
);
